import * as api from "./apis/ssoLogin";
import { setTokens } from "./setTokens";
import { MfaRequiredError } from "../utils/GqlError";
import { emit } from "../utils/eventManager";
import { sendNewRelicEvent } from "../utils/newRelicEvents";
export { ssoLogin };
async function ssoLogin(provider, email, accessToken) {
  try {
    sendNewRelicEvent({
      EventName: 'sso_login_start',
      provider: provider
    });
    var tokens = await api.ssoLogin(provider, email, accessToken);
    var idToken = tokens.idToken,
      accessTokenInner = tokens.accessToken;
    emit('login.success', {
      tokens: tokens
    });
    sendNewRelicEvent({
      EventName: 'sso_login_success',
      provider: provider
    });
    await setTokens({
      idToken: idToken,
      accessToken: accessTokenInner,
      callInitSession: true
    });
    return tokens;
  } catch (e) {
    if (e instanceof MfaRequiredError) {
      emit('mfa required', e.mfaPayload);
    }
    sendNewRelicEvent({
      EventName: 'sso_login_failed',
      provider: provider,
      error: e
    });
    throw e;
  }
}